import React, { useEffect } from 'react';
import SongSelector from '../components/SongSelector';
import avatarImage from '../assets/IMG_9833_inPixio.png';
import professionalProfileImage from '../assets/IMG_9835_inPixio.png';
import { aboutIntro, aboutProfile } from '../content/aboutContent';

function Home({ theme }) {
  // Reset the figure position when home page loads
  useEffect(() => {
    if (theme !== 'ddr') return;
    const figureContainer = document.querySelector('.figure-container');
    if (figureContainer) {
      figureContainer.classList.remove('transitioning');
    }
  }, [theme]);

  if (theme === 'professional') {
    return (
      <div className="professional-page">
        <div className="professional-home-center">
          <main className="professional-content professional-home-surrounding-card">
            <section className="professional-hero">
              <div className="professional-profile-image-frame">
                <img
                  src={professionalProfileImage}
                  alt={`${aboutProfile.name} profile`}
                  className="professional-profile-image"
                />
              </div>
              <div>
                <h1>{aboutProfile.name}</h1>
                <p className="professional-subtitle">{aboutProfile.role}</p>
                <p>{aboutIntro}</p>
              </div>
            </section>

            <section className="professional-skill-cards" aria-label="Core skills">

              <article className="professional-skill-card">
                <h3>Backend Development</h3>
                <ul>
                  <li>API design and development</li>
                  <li>Database architecture</li>
                  <li>Real-time systems</li>
                </ul>
              </article>
              <article className="professional-skill-card">
                <h3>DevOps &amp; Cloud</h3>
                <ul>
                  <li>GCP & AWS Solutions Architect</li>
                  <li>CI/CD pipelines</li>
                  <li>Scalable deployments</li>
                </ul>
              </article>
              <article className="professional-skill-card">
                <h3>Frontend Development</h3>
                <ul>
                  <li>Modern React architecture</li>
                  <li>Performance optimization</li>
                  <li>Responsive and accessible UI</li>
                </ul>
              </article>
            </section>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <div className="home-background">
        <div className="home-gradient"></div>
      </div>
      <div className="home-content">
        <div className="avatar-section">
          <div className="avatar-container">
            <img src={avatarImage} alt="Avatar" className="avatar-image" />
          </div>
        </div>
        <div className="song-selector-section">
          <SongSelector showHeader={false} />
        </div>
      </div>
    </div>
  );
}

export default Home; 